module.exports = __webpack_public_path__ + "img/线条猫耳朵.7a4870b8.png";